module.exports = __webpack_public_path__ + "static/media/google-authenticator-exp.35c9e67d.png";